import React, { Component} from 'react';
import Dashboard from 'containers/Dashboard/Dashboard';
import { connect } from 'react-redux';

class SponsorsDashboard extends Component {
  constructor(props) {
    super(props);
  }

  sponsor = () => {
    const { sponsors } = this.props;
    const routeNamespace = this.props.location.pathname.replace(/\//, '');

    const matchedValue = sponsors.find(el => {
      const namespace = (el.namespace || '').toLowerCase().replace(/\//, '');
      const match = routeNamespace.match(`^${namespace}$`);
      const reverseMatch = namespace.match(`^${routeNamespace}$`);
      return !!match || !!reverseMatch;
    });

    if (!matchedValue) {
      this.props.router.push('/');
    }

    return matchedValue;
  }

  render() {
    return (
      <Dashboard sponsor={this.sponsor()} />
    );
  }
}

function mapStateToProps(state) {
  return {
    sponsors: state.sponsors.list.values
  };
}

export default connect(mapStateToProps)(SponsorsDashboard);



// WEBPACK FOOTER //
// ./src/containers/SponsorsDashboard/index.js